import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const ImgPlaceholder = ({
    style,
    img,
    placeholder,
    className,
    alt
}: any) => {


    const [state, setState] = useState({
        img: img
    })

    return (
        <img
            alt={alt ?? "Redsmart"}
            className={className ?? ""}
            style={{
                ...style,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%'
            }}
            onError={() => {
                setState((s: any) => {
                    return {
                        ...s,
                        img: placeholder
                    }
                });
            }}
            src={state.img} />
    )
}

ImgPlaceholder.propTypes = {
    style: PropTypes.any,
    img: PropTypes.any.isRequired,
    placeholder: PropTypes.any.isRequired,
    className: PropTypes.string,
    alt: PropTypes.string
}